var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVesselImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4201 12.3697C20.8513 12.5581 21.2057 12.8872 21.4255 13.3031C21.6453 13.7191 21.7175 14.1974 21.6301 14.6597L21.2201 16.5197C20.9207 18.0987 20.0669 19.5187 18.8127 20.5236C17.5584 21.5284 15.9864 22.0519 14.3801 21.9997H9.62011C8.01384 22.0519 6.4418 21.5284 5.18757 20.5236C3.93334 19.5187 3.07951 18.0987 2.78011 16.5197L2.37011 14.6597C2.28276 14.1974 2.35489 13.7191 2.5747 13.3031C2.7945 12.8872 3.14897 12.5581 3.58011 12.3697L5.00011 11.7997L10.5101 9.58972C11.4671 9.20968 12.5331 9.20968 13.4901 9.58972L19.0001 11.7997L20.4201 12.3697Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22V10",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8V11.8L13.49 9.59C12.533 9.20996 11.467 9.20996 10.51 9.59L5 11.8V8C5.00237 7.20508 5.31921 6.4434 5.8813 5.8813C6.4434 5.31921 7.20508 5.00237 8 5H16C16.7949 5.00237 17.5566 5.31921 18.1187 5.8813C18.6808 6.4434 18.9976 7.20508 19 8V8Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5H9.5V3C9.5 2.73478 9.60536 2.48043 9.79289 2.29289C9.98043 2.10536 10.2348 2 10.5 2H13.5C13.7652 2 14.0196 2.10536 14.2071 2.29289C14.3946 2.48043 14.5 2.73478 14.5 3V5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselImg);
export default __webpack_public_path__ + "static/media/VesselImg.7a2b24559f5b2eb791bd7dadc3fc38d3.svg";
export { ForwardRef as ReactComponent };